const attendance = [
  {
    Class: "VII",
    Sec: "A",
    Present: 14,
    Absent: 19,
  },
  {
    Class: "V" ,
    Sec: "A",
    Present: 10, 
    Absent: 3,
  },
  {
    Class: "X",
    Sec: "D",
    Present: 20,
    Absent: 9,
  },
  {
    Class: "IX",
    Sec: "C",
    Present: 30,
    Absent: 3,
  },
];

export default attendance;
